import { PartnerListPage } from '@/features/partners/components/partner-list-page';

export function PartnerSuppliersRoute(): JSX.Element {
  return (
    <PartnerListPage
      type="supplier"
      titleKey="partners.suppliers.title"
      subtitleKey="partners.suppliers.subtitle"
      createLabelKey="partners.actions.createSupplier"
      formPreset="supplier"
    />
  );
}
